import React from 'react'
import { Button, Card, Descriptions, Space, Typography } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import StatusTag from './StatusTag'
const { Text } = Typography

export interface SummaryItem {
    label: string
    value?: React.ReactNode
    // Shown as copyable code instead of `value`
    copy?: string
}

interface EntitySummaryProps {
    title: string
    status: string
    statusLabel: string
    items: SummaryItem[]
    refreshing?: boolean
    onRefresh: () => void
    extra?: React.ReactNode
    children?: React.ReactNode
}

const hasValue = (item: SummaryItem) => !!item.copy || (item.value !== undefined && item.value !== null && item.value !== '')

const EntitySummary: React.FC<EntitySummaryProps> = ({ title, status, statusLabel, items, refreshing, onRefresh, extra, children }) => (
    <Card
        title={title}
        className="entity-summary"
        extra={
            <Space>
                {extra}
                <Button size="small" icon={<ReloadOutlined spin={refreshing} />} onClick={onRefresh} disabled={refreshing}>
                    Refresh
                </Button>
            </Space>
        }
    >
        <Descriptions column={{ xs: 1, sm: 2 }} size="small" colon={false}>
            <Descriptions.Item label="Status">
                <StatusTag status={status} label={statusLabel} />
            </Descriptions.Item>
            {items.filter(hasValue).map((item) => (
                <Descriptions.Item key={item.label} label={item.label}>
                    {item.copy ? (
                        <Text code copyable>
                            {item.copy}
                        </Text>
                    ) : (
                        item.value
                    )}
                </Descriptions.Item>
            ))}
        </Descriptions>
        {children}
    </Card>
)

export default EntitySummary
